import React from 'react';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';

const ProductListByCategory = (props) => {
  const distID = localStorage.getItem('distributorId');
  const PCID = props.id;
  const { data, error, isLoaded } = GetRequest(`/Product/GetProductLinesByCategoryForDistributor/${PCID}/${distID}`);

  if (error !== null) {
    return <Error data=" " />;
  }
  if (!isLoaded) {
    return <Loading />;
  }

  return (
    <>
      {data.result &&
        data.result.map((items) => (
          <div key={items.id} className="col-12 col-sm-6 col-md-4 itemfiltered" data-item={PCID}>
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-sm-12 centerImage">
                    {items.productSmallImage ? (
                      <img className="ProductsInfoHeadImg fade-in" src={items.productSmallImage} alt="Product" />
                    ) : (
                      <i className="fa fa-file-image-o dumProdBigIcon"></i>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 bgHeadPI" data-bs-toggle="collapse" href={`#collapse${items.id}`}>
                    <label className="prHeadName">
                      {items.name}
                      {!items.isOrderedBefore && (
                        <span className="never-ordered-badge">Never Ordered</span>
                      )}
                    </label>
                    <a className="btn dp-right-mt5">
                      <i className="fa fa-angle-double-down"></i>
                      <i className="fa fa-angle-double-up"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div id={`collapse${items.id}`} className="collapse" data-bs-parent="#accordion">
                <div className="card-body">
                  {items.punchLine1 && (
                    <p className="text-center">
                      <button type="button" className="btn btn-outline-primary btn-block">
                        {items.punchLine1}
                      </button>
                    </p>
                  )}

                  {!items.isOrderedBefore && (
                    <p className="never-ordered bounce">
                      🚨 <b>Never Ordered</b> 🚨
                    </p>
                  )}

                  <p><b>Rate:</b> {items.costPerAcre || 'N/A'}</p>
                  {items.technicalName && <p><b>Technical Name:</b> {items.technicalName}</p>}
                  {items.dosageInformation && <p><b>Dosage:</b> {items.dosageInformation}</p>}
                  {items.diseaseOrPestsCovered && <p><b>Coverage:</b> {items.diseaseOrPestsCovered}</p>}
                  {items.cropsRecommendedOn && <p><b>Crops:</b> {items.cropsRecommendedOn}</p>}
                  {items.description && <p><b>Details:</b> {items.description}</p>}
                </div>
                <div className="mt-4 testimonials-section p-3 bg-light rounded shadow-sm">
                  <h5 className="mb-3 text-primary border-bottom pb-2">
                    <i className="fa fa-commenting-o me-2"></i> Farmer Testimonials
                  </h5>
                  {items.testimonialMlinfoList.map((t, index) => (
                    <div key={index} className="testimonial-card bg-white border p-3 mb-3 rounded shadow-sm">
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                        <div className="flex-grow-1">
                          <p className="mb-1"><b>👤 Farmer:</b> {t.farmerName} ({t.village}, {t.district})</p>
                          {t.problemStatement && (
                            <p className="mb-1"><b>🪲 Problem:</b> {t.problemStatement}</p>
                          )}
                          {t.result && (
                            <p className="mb-1"><b>🌱 Result:</b> {t.result}</p>
                          )}
                          <div className="d-flex flex-wrap mt-2">
                            {t.videoLink1 && (
                              <a
                                href={t.videoLink1}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-danger me-2 mb-2"
                              >
                                🎥 Watch Video
                              </a>
                            )}
                            {t.documentUrl1 && (
                              <a
                                href={t.documentUrl1}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-secondary me-2 mb-2"
                              >
                                📄 View Document
                              </a>
                            )}
                          </div>
                        </div>
                        {t.farmerPhoto1 && (
                          <div className="ms-md-3 mt-3 mt-md-0">
                            <img
                              src={t.farmerPhoto1}
                              alt="Farmer"
                              className="img-fluid rounded"
                              style={{ maxWidth: '120px' }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default ProductListByCategory;
